export default "__VITE_ASSET__DC7LI53$__"